<template>
    <v-row class="nitg__quote">
        <v-col cols="12" class="pa-lg-12">
            <transition enter-active-class="transition-ease-in-out"
                        leave-active-class="transition-ease-in-out">
                <p class="text-h4">{{ quote.text | quote }}</p>
            </transition>
            <transition enter-active-class="transition-ease-in-out"
                        leave-active-class="transition-ease-in-out">
                <p class="text-right">
                    <small class="title">{{ quote.author | dash }}</small>
                </p>
            </transition>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "QuotesComponent",
        data() {
            return {
                quote: {
                    text: null,
                    author: null
                },
                interval: null
            }
        },
        mounted() {
            this.getQuote();
            this.fetchEntriesDebounced();
        },
        methods: {
            getQuote() {
                this.$httpService.get('api/v2/search/quote')
                    .then(response => {
                        this.quote = response.data.quote;
                    })
            },
            fetchEntriesDebounced() {
                clearInterval(this.interval);
                this.interval = setInterval(() => {
                    this.getQuote()
                }, 1000 * 60)
            }
        }
    }
</script>

<style scoped>

</style>
